// extracted by mini-css-extract-plugin
module.exports = {"Container":"Edit_Container__1TM0B"};